import './columnAlign.css'

/** align content in multiple columns, 1st is left-aligned, last is right, & others are centered */
export function ColumnAlign(props: {
  readonly width?: string | number;
  readonly children: JSX.Element[],
}) {
  const verticalAlign = 'top';

  // note that 'margin:auto' centers the content in the parent
  return (<div style={{ width: props.width, margin: 'auto' }}>
    <table style={{ width: props.width }}>
      <tbody><tr>
        {props.children.map((c, i) => {
          const textAlign = i === 0 ? 'left' : i === props.children.length - 1 ? 'right' : 'center';
          return <td style={{ textAlign, verticalAlign }} className='clean' key={i.toString()}>{c}</td>;
        })}
      </tr></tbody>
    </table>
  </div>);
}
